import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AccessibilityContext = createContext(null);

const TEXT_SCALES = { normal: 1, large: 1.15, xlarge: 1.3 };

export function AccessibilityProvider({ children }) {
  const [highContrast, setHighContrast] = useState(() => localStorage.getItem("a11y_high_contrast") === "true");
  const [textScale, setTextScale] = useState(() => localStorage.getItem("a11y_text_scale") || "normal");

  useEffect(() => {
    document.documentElement.classList.toggle("high-contrast", highContrast);
    localStorage.setItem("a11y_high_contrast", highContrast);
  }, [highContrast]);

  useEffect(() => {
    localStorage.setItem("a11y_text_scale", textScale);
  }, [textScale]);

  const save = (prefs) => api.put("/auth/preferences", prefs).catch(() => {});

  const applyAccount = useCallback((prefs) => {
    if (prefs.text_scale && TEXT_SCALES[prefs.text_scale]) setTextScale(prefs.text_scale);
    if (typeof prefs.high_contrast === "boolean") setHighContrast(prefs.high_contrast);
  }, []);

  return (
    <AccessibilityContext.Provider
      value={{
        highContrast,
        toggleHighContrast: () => {
          const next = !highContrast;
          setHighContrast(next);
          save({ high_contrast: next });
        },
        textScale,
        textScaleValue: TEXT_SCALES[textScale] || 1,
        setTextScale: (scale) => {
          setTextScale(scale);
          save({ text_scale: scale });
        },
        applyAccount,
      }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
}

export function useAccessibility() {
  return useContext(AccessibilityContext);
}
